/* ============================================================================
FILE: po-katupirsia9-pulse-959-texts-fr-en-es-20260326.js
MODE: manual protected trilingual injection + audio layer
API:  window.PoK9Pulse959TextsFR_EN_ES_20260326
ROOT: .po-axis-section[data-po-axis='pulse_959']
ROLE:
  - Bloque les traductions extérieures sur le bloc.
  - Active uniquement la traduction interne via boutons FR / EN / ES.
  - Verrouille le vocabulaire canonique et ses caractères spéciaux.
  - CTA fin de page via slot : cta_translate.
  - Ajoute une lecture audio générale et locale par bloc sans remplacer le système existant.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_K9_PULSE_959_TEXTS_20260326__) return;
  window.__PO_K9_PULSE_959_TEXTS_20260326__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var ROOT_SELECTOR = ".po-axis-section[data-po-axis='pulse_959']";

  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Pulse_959_icone.png?v=1772925919";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Pulse_959_fonctionnel.png?v=1773289899";
  var RELATED_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Annee_Posoenoiale_copie.png?v=1772925681";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toUpperCase().trim();
    if (s === "EN" || s === "ES") return s;
    return "FR";
  }

  function detectRawLang(){
    if (typeof window !== "undefined" && window.PO_SITE_LANG) return window.PO_SITE_LANG;
    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return dl;
    var nav = (typeof navigator !== "undefined") ? navigator : null;
    if (nav && nav.languages && nav.languages.length) return nav.languages[0] || "";
    if (nav && nav.language) return nav.language || "";
    return "fr";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      if (v) return normLang(v);
    }catch(e){}
    var raw = clampStr(detectRawLang()).toLowerCase();
    if (raw.indexOf("en") === 0) return "EN";
    if (raw.indexOf("es") === 0 || raw.indexOf("pt") === 0) return "ES";
    return "FR";
  }

  function storeLang(lang3){
    try{ localStorage.setItem(STORAGE_KEY, normLang(lang3)); }catch(e){}
  }

  function nt(txt){
    return '<span class="notranslate" translate="no">' + clampStr(txt) + '</span>';
  }

  var COPY = {
    FR: {
      title: "Pulse 959",
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 - Àṣẹxel’Or</em><br />(Année posœnnoïale, redistribution du surplus astronomique et mode rituel)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel", "Année posœnnoïale"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL, RELATED_URL],
      def_short: "Le Pulse 959 est une pratique posœnnoïale qui matérialise et incarne la redistribution de l’excédent astronomique annuel. Il en propose le mode rituel : 599 s par décade, soit 9 min 59 s vécues comme souffle, geste et seuil.",
      def_long:
        "<p>Dans " + nt("Katûpirsia 9") + ", le " + nt("Pulse 959") + " apparaît comme le <em>mode rituel</em> de redistribution du surplus annuel. Là où le mode exact répartit environ 581 s par décade, le " + nt("Pulse 959") + " assume un arrondi opératif : <em>599 s = 9 min 59 s</em>, afin que la rigueur astronomique devienne expérience vécue.</p>" +
        "<p>Le rituel se déploie en quatre phases : <em>3 minutes de silence</em>, <em>3 minutes de mouvement spiralé</em>, <em>3 minutes de respiration rythmée</em> accordée sur le rapport <em>22:7</em>, puis <em>59 secondes de seuil</em>. Le calcul cesse alors d’être abstraction : il devient intériorisation, inscription corporelle, souffle aligné et passage.</p>" +
        "<p>Le corpus insiste sur sa portée symbolique : le 9 répété reconduit au 9 d’accomplissement et de transmutation ; les 59 secondes ouvrent un passage du fini vers l’infini ; la spirale redistributive substitue à la correction mécanique une respiration du temps. " + nt("Pulse 959") + " relie ainsi matière temporelle, corps et conscience.</p>" +
        "<p>Son idéogramme condense cette logique en un seul geste : trait vertical d’élévation, courbe spiralée de redistribution et 9 inscrit comme seuil de bascule. La page conserve donc les deux idéogrammes propres au " + nt("Pulse 959") + " attestés dans la liste iconographique, et place en troisième visuel l’idéogramme conceptuel de l’" + nt("Année posœnnoïale") + ", explicitement articulée au Pulse dans K9.</p>",
      h_features: "Dynamiques attestées",
      h_questions: "Repères d’usage",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      hint_fold: "déplier",
      example_title: "Ex.",
      example: "À chaque décade, réserver 9 min 59 s pour faire passer l’excédent du temps solaire dans le corps : silence, mouvement spiralé, respiration rythmée, puis seuil suspendu.",
      features: [
        "Mode rituel de redistribution : 599 s par décade, soit 9 min 59 s.",
        "Séquence canonique : 3 min silence, 3 min mouvement spiralé, 3 min respiration (22:7), 59 s seuil.",
        "Fonction opérative : absorber l’excédent en souffle vécu, relier temps, corps et conscience.",
        "Principe directeur : l’exactitude est double, mathématique et vibratoire."
      ],
      questions: [
        "Comment transformer un excédent temporel ou un décalage en souffle vécu plutôt qu’en correction sèche ?",
        "La séquence 3–3–3–59 est-elle tenue comme rythme, comme geste et comme passage ?",
        "Quel seuil s’ouvre lorsque le calcul devient respiration et conscience ?",
        "Le rituel pratiqué reconduit-il vers la redistribution spiralée du temps plutôt que vers une simple compensation mécanique ?"
      ],
      family_1: "<p><strong>Insertion temporelle :</strong> dans K9, " + nt("Pulse 959") + " s’inscrit dans l’architecture de l’" + nt("Année posœnnoïale") + ". Il redistribue l’excédent annuel sur les 36 décades, puis laisse apparaître un résidu qui peut être absorbé par les épagomènes, les saisons ou un rituel d’" + nt("Équiphase") + ".</p>",
      family_2: "<p><strong>Liens internes :</strong> le corpus le relie au " + nt("Sceau d’Équiphase") + ", à " + nt("Threnisqun") + " et à la logique selon laquelle le surplus n’est pas supprimé mais transmuté. " + nt("Pulse 959") + " convertit ainsi une donnée astronomique en pratique rituelle, en sceau graphique et en mémoire visible du temps spiralé.</p>",
      word_blocks: [
        { head: "1) Pulse", text: "Battement, pulsation, rythme vécu : le temps y devient souffle perceptible et réglage incarné." },
        { head: "2) 959", text: "599 s vécues comme 9 min 59 s : un arrondi opératif où le 9 d’accomplissement se répète et se rouvre." },
        { head: "3) Pulse 959", text: "Nom d’un mode rituel de redistribution : l’excédent astronomique se transforme en séquence praticable, en signe et en conscience." }
      ],
      word_notes: [
        "Mode exact : environ 581 s par décade ; mode rituel : 599 s par décade.",
        "Troisième visuel retenu : Année posœnnoïale (conceptuel), explicitement articulée au Pulse 959 dans K9."
      ],
      cta_translate: "Proposer une traduction du concept",
      langbar_aria: "Choix de langue",
      audio_general: "Écouter le texte",
      audio_block: "Écouter ce bloc",
      audio_stop: "Arrêter la lecture"
    },
    EN: {
      title: "Pulse 959",
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 - Àṣẹxel’Or</em><br />(Année posœnnoïale, redistribution of the astronomical surplus, and ritual mode)",
      h_def: "Operative definition",
      chips: ["Concept ideogram", "Functional ideogram", "Année posœnnoïale"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL, RELATED_URL],
      def_short: "Pulse 959 is a posœnnoïal practice that materializes and embodies the redistribution of the annual astronomical surplus. It proposes its ritual mode: 599 s per decade, that is 9 min 59 s lived as breath, gesture, and threshold.",
      def_long:
        "<p>In " + nt("Katûpirsia 9") + ", " + nt("Pulse 959") + " appears as the <em>ritual mode</em> for redistributing the annual surplus. Where the exact mode distributes about 581 s per decade, " + nt("Pulse 959") + " assumes an operative rounding: <em>599 s = 9 min 59 s</em>, so that astronomical rigor becomes lived experience.</p>" +
        "<p>The ritual unfolds in four phases: <em>3 minutes of silence</em>, <em>3 minutes of spiral movement</em>, <em>3 minutes of rhythmic breathing</em> tuned to the <em>22:7</em> ratio, then <em>59 seconds of threshold</em>. Calculation then ceases to be abstraction: it becomes interiorization, bodily inscription, aligned breath, and passage.</p>" +
        "<p>The corpus insists on its symbolic scope: the repeated 9 returns to the 9 of accomplishment and transmutation; the 59 seconds open a passage from the finite toward the infinite; the redistributive spiral replaces mechanical correction with a respiration of time. " + nt("Pulse 959") + " thus links temporal matter, body, and consciousness.</p>" +
        "<p>Its ideogram condenses this logic into a single gesture: a vertical line of elevation, a spiral curve of redistribution, and a 9 inscribed as a threshold of turning. The page therefore keeps the two ideograms specific to " + nt("Pulse 959") + " attested in the iconographic list, and places as the third visual the conceptual ideogram of the " + nt("Année posœnnoïale") + ", explicitly articulated with the Pulse in K9.</p>",
      h_features: "Attested dynamics",
      h_questions: "Usage markers",
      h_family: "Systemic links",
      h_wordbuild: "Term construction",
      hint_fold: "expand",
      example_title: "Ex.",
      example: "At each decade, reserve 9 min 59 s to let the surplus of solar time pass into the body: silence, spiral movement, rhythmic breathing, then a suspended threshold.",
      features: [
        "Ritual mode of redistribution: 599 s per decade, that is 9 min 59 s.",
        "Canonical sequence: 3 min silence, 3 min spiral movement, 3 min breathing (22:7), 59 s threshold.",
        "Operative function: absorb the surplus into lived breath, linking time, body, and consciousness.",
        "Guiding principle: exactitude is double, mathematical and vibratory."
      ],
      questions: [
        "How can a temporal surplus or lag be transformed into lived breath rather than into a dry correction?",
        "Is the 3–3–3–59 sequence truly held as rhythm, gesture, and passage?",
        "What threshold opens when calculation becomes breath and consciousness?",
        "Does the practiced ritual lead back toward spiral redistribution of time rather than toward simple mechanical compensation?"
      ],
      family_1: "<p><strong>Temporal insertion:</strong> in K9, " + nt("Pulse 959") + " is part of the architecture of the " + nt("Année posœnnoïale") + ". It redistributes the annual surplus across the 36 decades, then lets a residue appear that can be absorbed by the epagomenal days, the seasons, or an " + nt("Équiphase") + " ritual.</p>",
      family_2: "<p><strong>Internal links:</strong> the corpus connects it to the " + nt("Sceau d’Équiphase") + ", to " + nt("Threnisqun") + ", and to the logic according to which the surplus is not removed but transmuted. " + nt("Pulse 959") + " thus converts an astronomical datum into ritual practice, graphic seal, and visible memory of spiral time.</p>",
      word_blocks: [
        { head: "1) Pulse", text: "Beat, pulsation, lived rhythm: time becomes perceptible breath and embodied adjustment." },
        { head: "2) 959", text: "599 s lived as 9 min 59 s: an operative rounding in which the 9 of accomplishment repeats and reopens itself." },
        { head: "3) Pulse 959", text: "Name of a ritual mode of redistribution: the astronomical surplus becomes a practicable sequence, a sign, and a consciousness." }
      ],
      word_notes: [
        "Exact mode: about 581 s per decade; ritual mode: 599 s per decade.",
        "Third visual retained: Année posœnnoïale (conceptual), explicitly articulated with Pulse 959 in K9."
      ],
      cta_translate: "Suggest a translation of the concept",
      langbar_aria: "Language selection",
      audio_general: "Listen to the text",
      audio_block: "Listen to this block",
      audio_stop: "Stop playback"
    },
    ES: {
      title: "Pulse 959",
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 - Àṣẹxel’Or</em><br />(Année posœnnoïale, redistribución del excedente astronómico y modo ritual)",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional", "Année posœnnoïale"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL, RELATED_URL],
      def_short: "Pulse 959 es una práctica posœnnoïal que materializa y encarna la redistribución del excedente astronómico anual. Propone su modo ritual: 599 s por década, es decir 9 min 59 s vividos como soplo, gesto y umbral.",
      def_long:
        "<p>En " + nt("Katûpirsia 9") + ", " + nt("Pulse 959") + " aparece como el <em>modo ritual</em> de redistribución del excedente anual. Allí donde el modo exacto reparte alrededor de 581 s por década, " + nt("Pulse 959") + " asume un redondeo operativo: <em>599 s = 9 min 59 s</em>, para que el rigor astronómico se vuelva experiencia vivida.</p>" +
        "<p>El ritual se despliega en cuatro fases: <em>3 minutos de silencio</em>, <em>3 minutos de movimiento espiral</em>, <em>3 minutos de respiración ritmada</em> ajustada a la relación <em>22:7</em>, y luego <em>59 segundos de umbral</em>. El cálculo deja entonces de ser abstracción: se vuelve interiorización, inscripción corporal, soplo alineado y pasaje.</p>" +
        "<p>El corpus insiste en su alcance simbólico: el 9 repetido reconduce al 9 de cumplimiento y transmutación; los 59 segundos abren un paso de lo finito a lo infinito; la espiral redistributiva sustituye la corrección mecánica por una respiración del tiempo. " + nt("Pulse 959") + " enlaza así materia temporal, cuerpo y conciencia.</p>" +
        "<p>Su ideograma condensa esta lógica en un solo gesto: trazo vertical de elevación, curva espiral de redistribución y 9 inscrito como umbral de basculación. La página conserva así los dos ideogramas propios de " + nt("Pulse 959") + " atestiguados en la lista iconográfica, y coloca como tercer visual el ideograma conceptual de la " + nt("Année posœnnoïale") + ", articulada explícitamente con el Pulse en K9.</p>",
      h_features: "Dinámicas atestiguadas",
      h_questions: "Puntos de referencia",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      hint_fold: "desplegar",
      example_title: "Ej.",
      example: "En cada década, reservar 9 min 59 s para hacer pasar el excedente del tiempo solar al cuerpo: silencio, movimiento espiral, respiración ritmada y luego umbral suspendido.",
      features: [
        "Modo ritual de redistribución: 599 s por década, es decir 9 min 59 s.",
        "Secuencia canónica: 3 min silencio, 3 min movimiento espiral, 3 min respiración (22:7), 59 s umbral.",
        "Función operativa: absorber el excedente en un soplo vivido, enlazando tiempo, cuerpo y conciencia.",
        "Principio rector: la exactitud es doble, matemática y vibratoria."
      ],
      questions: [
        "¿Cómo transformar un excedente temporal o un desfase en un soplo vivido y no en una corrección seca?",
        "¿La secuencia 3–3–3–59 se sostiene realmente como ritmo, gesto y pasaje?",
        "¿Qué umbral se abre cuando el cálculo se vuelve respiración y conciencia?",
        "¿El ritual practicado reconduce hacia la redistribución espiral del tiempo y no hacia una simple compensación mecánica?"
      ],
      family_1: "<p><strong>Inserción temporal:</strong> en K9, " + nt("Pulse 959") + " se inscribe en la arquitectura de la " + nt("Année posœnnoïale") + ". Redistribuye el excedente anual sobre las 36 décadas y deja aparecer luego un residuo que puede ser absorbido por los epagómenos, las estaciones o un ritual de " + nt("Équiphase") + ".</p>",
      family_2: "<p><strong>Vínculos internos:</strong> el corpus lo relaciona con el " + nt("Sceau d’Équiphase") + ", con " + nt("Threnisqun") + " y con la lógica según la cual el excedente no se suprime sino que se transmuta. " + nt("Pulse 959") + " convierte así un dato astronómico en práctica ritual, sello gráfico y memoria visible del tiempo espiral.</p>",
      word_blocks: [
        { head: "1) Pulse", text: "Latido, pulsación, ritmo vivido: el tiempo se vuelve soplo perceptible y ajuste encarnado." },
        { head: "2) 959", text: "599 s vividos como 9 min 59 s: un redondeo operativo en el que el 9 del cumplimiento se repite y se reabre." },
        { head: "3) Pulse 959", text: "Nombre de un modo ritual de redistribución: el excedente astronómico se transforma en secuencia practicable, en signo y en conciencia." }
      ],
      word_notes: [
        "Modo exacto: alrededor de 581 s por década; modo ritual: 599 s por década.",
        "Tercer visual retenido: Année posœnnoïale (conceptual), articulada explícitamente con Pulse 959 en K9."
      ],
      cta_translate: "Proponer una traducción del concepto",
      langbar_aria: "Selección de idioma",
      audio_general: "Escuchar el texto",
      audio_block: "Escuchar este bloque",
      audio_stop: "Detener la lectura"
    }
  };

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = clampStr(html);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    if (src) el.setAttribute("src", clampStr(src));
    if (alt) el.setAttribute("alt", clampStr(alt));
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    for (var i = 0; i < (items || []).length; i++){
      var li = document.createElement("li");
      li.textContent = clampStr(items[i]);
      el.appendChild(li);
    }
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    for (var i = 0; i < (blocks || []).length; i++){
      var b = blocks[i] || {};
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.textContent = clampStr(b.head || "");
      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.textContent = clampStr(b.text || "");
      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    }
  }

  function updateLangButtons(root, lang3){
    var btns = root.querySelectorAll(".po-langbtn[data-po-lang]");
    for (var i = 0; i < btns.length; i++){
      var active = normLang(btns[i].getAttribute("data-po-lang")) === lang3;
      btns[i].classList.toggle("is-active", active);
      btns[i].setAttribute("aria-pressed", active ? "true" : "false");
    }
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new CustomEvent("po:locale-changed", { detail: { lang: readStoredLang() } }));
    }catch(e){
      try{
        var ev = document.createEvent("CustomEvent");
        ev.initCustomEvent("po:locale-changed", true, true, { lang: readStoredLang() });
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* ============================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ============================================================================ */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: "",
    isStopping: false
  };

  function audioUI(lang3){
    var C = COPY[normLang(lang3)] || COPY.FR;
    return {
      general: C.audio_general,
      block: C.audio_block,
      stop: C.audio_stop
    };
  }

  function getSpeechLang(lang3){
    var L = normLang(lang3);
    if (L === "EN") return "en-US";
    if (L === "ES") return "es-ES";
    return "fr-FR";
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-k9-pulse-959-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-k9-pulse-959-audio-styles";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;justify-content:flex-start;align-items:center;margin:10px 0 12px;}" +
      ".po-axis-audio-btn{" +
        "appearance:none;border:1px solid rgba(0,0,0,.12);background:rgba(255,255,255,.66);" +
        "border-radius:999px;padding:7px 12px;font:inherit;font-size:12px;font-weight:700;" +
        "letter-spacing:.02em;cursor:pointer;transition:all .18s ease;line-height:1.2;}" +
      ".po-axis-audio-btn:hover{background:rgba(0,0,0,.04);}" +
      ".po-axis-audio-btn.is-playing{background:rgba(184,134,11,.08);border-color:rgba(184,134,11,.45);}" +
      ".po-axis-audio-btn[data-po-audio-kind='block']{margin-left:auto;flex:0 0 auto;}" +
      ".po-lex-summary{position:relative;}" +
      ".po-lex-summary__title{display:inline-flex;align-items:center;gap:10px;min-width:0;}" +
      "@media (max-width:760px){.po-axis-audio-btn{font-size:11px;padding:7px 10px;}}";
    document.head.appendChild(style);
  }

  function stopAudio(){
    PO_AUDIO_STATE.isStopping = true;
    try{
      if (PO_AUDIO_SYNTH) PO_AUDIO_SYNTH.cancel();
    }catch(e){}
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    clearPlayingButtons();
    setTimeout(function(){ PO_AUDIO_STATE.isStopping = false; }, 0);
  }

  function clearPlayingButtons(){
    var all = document.querySelectorAll(".po-axis-audio-btn.is-playing");
    for (var i = 0; i < all.length; i++) all[i].classList.remove("is-playing");
  }

  function setPlayingButtons(root, key){
    clearPlayingButtons();
    if (!root || !key) return;
    var btn = root.querySelector(".po-axis-audio-btn[data-po-audio-key='" + key + "']");
    if (btn) btn.classList.add("is-playing");
  }

  function cleanText(text){
    return clampStr(text)
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .replace(/\s+([,.;:!?])/g, "$1")
      .trim();
  }

  function getNodeText(el){
    if (!el) return "";
    return cleanText(el.textContent || el.innerText || "");
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i = 0; i < slots.length; i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      if (el) parts.push(getNodeText(el));
    }
    return cleanText(parts.join(" "));
  }

  function collectBlockText(details){
    if (!details) return "";
    var parts = [];
    var summaryTitle = details.querySelector(".po-lex-summary__title");
    if (summaryTitle) parts.push(getNodeText(summaryTitle));

    var clone = details.cloneNode(true);
    var summary = clone.querySelector("summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    var buttons = clone.querySelectorAll(".po-axis-audio-btn");
    for (var i = 0; i < buttons.length; i++){
      if (buttons[i] && buttons[i].parentNode) buttons[i].parentNode.removeChild(buttons[i]);
    }
    parts.push(getNodeText(clone));
    return cleanText(parts.join(" "));
  }

  function splitSpeechText(text){
    var source = cleanText(text);
    if (!source) return [];
    var maxLen = 210;
    var out = [];
    var current = "";
    var segments = source.split(/(?<=[\.\!\?\:\;])\s+/);

    function pushCurrent(){
      current = cleanText(current);
      if (current) out.push(current);
      current = "";
    }

    for (var i = 0; i < segments.length; i++){
      var seg = cleanText(segments[i]);
      if (!seg) continue;
      if (!current){
        current = seg;
      } else if ((current + " " + seg).length <= maxLen){
        current += " " + seg;
      } else {
        pushCurrent();
        if (seg.length <= maxLen){
          current = seg;
        } else {
          var words = seg.split(/\s+/);
          var buffer = "";
          for (var j = 0; j < words.length; j++){
            var w = words[j];
            if (!buffer){
              buffer = w;
            } else if ((buffer + " " + w).length <= maxLen){
              buffer += " " + w;
            } else {
              out.push(cleanText(buffer));
              buffer = w;
            }
          }
          current = buffer;
        }
      }
    }
    pushCurrent();
    return out;
  }

  function createUtterance(text, lang3, onEnd){
    var u = new SpeechSynthesisUtterance(text);
    u.lang = getSpeechLang(lang3);
    u.rate = 1;
    u.pitch = 1;
    u.volume = 1;
    u.onend = function(){ if (typeof onEnd === "function") onEnd(); };
    u.onerror = function(){ if (typeof onEnd === "function") onEnd(); };
    return u;
  }

  function speakChunks(chunks, lang3, done){
    if (!PO_AUDIO_SYNTH || !chunks.length){
      if (typeof done === "function") done();
      return;
    }
    var idx = 0;
    function next(){
      if (PO_AUDIO_STATE.isStopping) return;
      if (idx >= chunks.length){
        if (typeof done === "function") done();
        return;
      }
      var utter = createUtterance(chunks[idx], lang3, function(){ idx += 1; next(); });
      try{ PO_AUDIO_SYNTH.speak(utter); }
      catch(e){ idx += 1; next(); }
    }
    next();
  }

  function buildUnits(root){
    var units = [];
    var generalText = collectGeneralText(root);
    if (generalText){
      units.push({
        key: "general",
        type: "general",
        node: root,
        getText: function(){ return collectGeneralText(root); }
      });
    }
    var blocks = root.querySelectorAll(".po-lex-details");
    for (var i = 0; i < blocks.length; i++){
      (function(index, details){
        units.push({
          key: "block-" + index,
          type: "block",
          node: details,
          getText: function(){ return collectBlockText(details); }
        });
      })(i, blocks[i]);
    }
    return units;
  }

  function playUnitSequence(root, startIndex){
    if (!root || !PO_AUDIO_SYNTH) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root);
    PO_AUDIO_STATE.unitPos = startIndex;
    if (startIndex < 0 || startIndex >= PO_AUDIO_STATE.units.length) return;

    function playCurrent(){
      if (PO_AUDIO_STATE.isStopping) return;
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      if (!unit){ stopAudio(); return; }

      if (unit.type === "block" && unit.node && !unit.node.open) unit.node.open = true;

      PO_AUDIO_STATE.activeKey = unit.key;
      setPlayingButtons(root, unit.key);

      var txt = cleanText(unit.getText());
      var chunks = splitSpeechText(txt);
      var lang3 = readStoredLang();

      if (!chunks.length){
        PO_AUDIO_STATE.unitPos += 1;
        if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) stopAudio();
        else playCurrent();
        return;
      }

      speakChunks(chunks, lang3, function(){
        if (PO_AUDIO_STATE.isStopping) return;
        PO_AUDIO_STATE.unitPos += 1;
        if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) stopAudio();
        else playCurrent();
      });
    }

    playCurrent();
  }

  function createAudioButton(kind, key){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    return btn;
  }

  function updateAudioButtonLabels(root, lang3){
    var ui = audioUI(lang3);
    var all = root.querySelectorAll(".po-axis-audio-btn");
    for (var i = 0; i < all.length; i++){
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind");
      var key = btn.getAttribute("data-po-audio-key") || "";
      var isPlaying = btn.classList.contains("is-playing");
      btn.textContent = isPlaying ? ui.stop : (kind === "general" ? ui.general : ui.block);
      btn.setAttribute("aria-label", btn.textContent);
      if (key === "general") btn.setAttribute("title", ui.general);
    }
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();
    var panel = root.querySelector(".po-lex-panel");
    if (!panel) return;

    var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
    if (!generalWrap){
      generalWrap = document.createElement("div");
      generalWrap.className = "po-axis-audio-wrap";
      generalWrap.setAttribute("data-po-audio-role", "general");
      generalWrap.appendChild(createAudioButton("general", "general"));

      var meta = panel.querySelector(".po-axis-meta");
      var defShort = panel.querySelector("[data-po-slot='def_short']");
      var firstDetails = panel.querySelector(".po-lex-details");

      if (meta && meta.parentNode === panel && meta.nextSibling) panel.insertBefore(generalWrap, meta.nextSibling);
      else if (defShort && defShort.parentNode === panel) panel.insertBefore(generalWrap, defShort);
      else if (firstDetails && firstDetails.parentNode === panel) panel.insertBefore(generalWrap, firstDetails);
      else panel.appendChild(generalWrap);
    }

    var details = root.querySelectorAll(".po-lex-details");
    for (var i = 0; i < details.length; i++){
      var summary = details[i].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-kind='block']");
      if (!btn){
        btn = createAudioButton("block", "block-" + i);
        summary.appendChild(btn);
      } else {
        btn.setAttribute("data-po-audio-key", "block-" + i);
      }
    }
  }

  function bindAudioHandlers(root){
    if (!root || root.__poAudioBound) return;
    root.__poAudioBound = true;

    root.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest(".po-axis-audio-btn") : null;
      if (!btn || !root.contains(btn)) return;

      ev.preventDefault();
      ev.stopPropagation();

      var key = btn.getAttribute("data-po-audio-key") || "";
      var isPlaying = btn.classList.contains("is-playing");

      if (isPlaying){
        stopAudio();
        updateAudioButtonLabels(root, readStoredLang());
        return;
      }

      var units = buildUnits(root);
      var startIndex = 0;
      for (var i = 0; i < units.length; i++){
        if (units[i].key === key){ startIndex = i; break; }
      }
      playUnitSequence(root, startIndex);
      updateAudioButtonLabels(root, readStoredLang());
    }, true);
  }

  function initAudioEverywhere(lang3){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++){
      ensureAudioButtons(roots[i]);
      bindAudioHandlers(roots[i]);
      updateAudioButtonLabels(roots[i], lang3);
    }
  }

  function render(root, lang3){
    var C = COPY[normLang(lang3)] || COPY.FR;

    root.classList.add("notranslate");
    root.setAttribute("translate", "no");

    var scope = root.querySelector(".po-lex-scope[data-po-lex-scope]");
    if (scope){
      scope.classList.add("notranslate");
      scope.setAttribute("translate", "no");
    }

    setSlotText(root, "title", C.title);
    setSlotHTML(root, "kicker", C.kicker);
    setSlotImgSrc(root, "title_img", C.chip_urls[0], C.title);

    setSlotText(root, "h_def", C.h_def);
    setSlotText(root, "chip_1", C.chips[0]);
    setSlotText(root, "chip_2", C.chips[1]);
    setSlotText(root, "chip_3", C.chips[2]);
    setSlotImgSrc(root, "chip_1_img", C.chip_urls[0], C.chips[0]);
    setSlotImgSrc(root, "chip_2_img", C.chip_urls[1], C.chips[1]);
    setSlotImgSrc(root, "chip_3_img", C.chip_urls[2], C.chips[2]);

    setSlotText(root, "def_short", C.def_short);
    setSlotHTML(root, "def_long", C.def_long);

    setSlotText(root, "h_features", C.h_features);
    setSlotText(root, "h_questions", C.h_questions);
    setSlotText(root, "h_family", C.h_family);
    setSlotText(root, "h_wordbuild", C.h_wordbuild);
    setSlotText(root, "hint_fold", C.hint_fold);
    setSlotText(root, "hint_fold2", C.hint_fold);
    setSlotText(root, "hint_fold3", C.hint_fold);
    setSlotText(root, "hint_fold4", C.hint_fold);
    setSlotText(root, "cta_translate", C.cta_translate);

    renderListInto(root, "features", C.features);
    renderListInto(root, "questions", C.questions);
    setSlotHTML(root, "example_box", "<div><strong>" + C.example_title + "</strong> " + clampStr(C.example) + "</div>");
    setSlotHTML(root, "family_1", C.family_1);
    setSlotHTML(root, "family_2", C.family_2);
    renderWordBlocks(root, "wordbuild_blocks", C.word_blocks);
    renderListInto(root, "wordbuild_notes", C.word_notes);

    updateLangButtons(root, normLang(lang3));
  }

  function applyLangEverywhere(lang3){
    lang3 = normLang(lang3);
    storeLang(lang3);
    var blocks = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < blocks.length; i++) render(blocks[i], lang3);
    initAudioEverywhere(lang3);
    notifyLocaleChanged();
  }

  function bindLangbars(){
    var blocks = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < blocks.length; i++){
      (function(root){
        var btns = root.querySelectorAll(".po-langbtn[data-po-lang]");
        for (var j = 0; j < btns.length; j++){
          if (btns[j].__po_bound) continue;
          btns[j].__po_bound = true;
          btns[j].addEventListener("click", function(){
            applyLangEverywhere(this.getAttribute("data-po-lang") || "FR");
          });
        }
      })(blocks[i]);
    }
  }

  function init(){
    bindLangbars();
    applyLangEverywhere(readStoredLang());
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.PoK9Pulse959TextsFR_EN_ES_20260326 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: readStoredLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
